import _ from 'lodash'

export const ignoredParameters = ['r', 'm', 'sa', 'q', 'sort']

export const getQueryKeys = (parameter) => {
  const queryKeys = []
  const subParameters = _.get(parameter, 'parameters', [])
  const subParametersQueryKeys = subParameters.map((item) => item.queryKey)

  if (parameter.queryKey) {
    queryKeys.push(parameter.queryKey)
  }
  if (subParametersQueryKeys.length > 0) {
    queryKeys.push(...subParametersQueryKeys)
  }
  if (parameter.rangeStart) {
    queryKeys.push(parameter.rangeStart.queryKey)
  }
  if (parameter.rangeEnd) {
    queryKeys.push(parameter.rangeEnd.queryKey)
  }

  return queryKeys
}

export const getAllQueryKeys = (parameters) => {
  const keys = []
  const getKeys = (value, indexOrKey) => {
    if (_.isArray(value) || _.isObject(value)) {
      _.map(value, getKeys)
    } else if (indexOrKey === 'queryKey') {
      keys.push(value)
    }
  }
  _.map(parameters, getKeys)
  return keys
}

export const parameterIsDefault = (parameter, parameterQuery) => {
  const queryKeys = getQueryKeys(parameter)
  let isDefault = true

  queryKeys.forEach((queryKey) => {
    if (parameterQuery[queryKey] && parameterQuery[queryKey] !== parameter.defaultValue) {
      isDefault = false
    }
  })

  return isDefault
}

export const nonDefaultParameters = (parameters, parameterQuery) => {
  let result = 0

  _.forEach(parameters, (parameter) => {
    const queryKeys = getQueryKeys(parameter)
    let nonDefault = false

    queryKeys.forEach((queryKey) => {
      if (_.includes(ignoredParameters, queryKey)) {
        return
      }
      nonDefault = !parameterIsDefault(parameter, parameterQuery)
    })

    if (nonDefault) {
      result += 1
    }
  })

  return result
}

const getTreeCollectionNodes = (currentLevel, target) => {
  let result = []
  let foundTargets

  currentLevel.items.forEach((item) => {
    if (item.value === target) {
      // Target found, push target to the result and break out of the recursion
      result.push(item)
      return
    }
    if (!item.items) {
      return
    }

    foundTargets = getTreeCollectionNodes(item, target)
    if (foundTargets.length > 0) {
      result = result.concat(item, foundTargets)
    }
  })

  return result
}

const getLayeredTreeNodes = (parameterData, parameterQuery) => {
  const queryKeys = [parameterData, ...parameterData.parameters]
  const activeQueryKeys = _.filter(queryKeys, ({ queryKey }) => parameterQuery[queryKey])
  const nodes = []
  let currentTarget = parameterData

  activeQueryKeys.forEach(({ queryKey }, index) => {
    currentTarget = _.find(currentTarget.items, { value: parameterQuery[queryKey] })

    nodes.push({
      ...currentTarget,
      queryKey,
      nextQueryKey: _.get(queryKeys[index + 1], 'queryKey', null),
    })
  })

  return nodes
}

// Accepts parameterData of the type `layered_tree` and `tree_collection`.
// Will find the nodes from the root the the leaf paths as specified in the
// `parameterQuery`
// The returned nodes are of the following format:
// nodes = [{
//   label,
//   queryKey,
//   nextQueryKey,
//   items,
// }, ..., {
//   label,
//   queryKey,
//   nextQueryKey,
// }]
//
// Nodes without the items prop will be a leaf node.
export const getTreeNodes = (parameterData, parameterQuery) => {
  let nodes = [
    {
      queryKey: parameterData.queryKey,
      nextQueryKey: parameterData.queryKey,
      label: parameterData.clearLabel,
      items: parameterData.items,
    },
  ]
  let target

  switch (parameterData.type) {
    case 'layered_tree':
      return nodes.concat(getLayeredTreeNodes(parameterData, parameterQuery))
    case 'tree_collection':
      target = _.get(parameterQuery, parameterData.queryKey, parameterData.defaultValue)
      nodes = nodes.concat(getTreeCollectionNodes(parameterData, target))
      return nodes.map((node) => ({
        ...node,
        queryKey: parameterData.queryKey,
        nextQueryKey: parameterData.queryKey,
      }))
    default:
      return nodes
  }
}

export const getLabel = (parameterData, parameterQuery) => {
  const match = _.last(getTreeNodes(parameterData, parameterQuery))
  return match.label
}

export const getTreeParent = (parameterData, parameterQuery) => {
  const match = _.nth(getTreeNodes(parameterData, parameterQuery), -2)
  return match
}

// Return only valid query parameters
// Note:
// No escaping of the query is done, this is left to the API.
// So the result shouldn't be deemed "safe" in any way.
export const cleanQuery = (query, state) => _.pick(query, state.searchParams.validQueryKeys)
